export default __webpack_public_path__ + "static/media/dmente_yellow_background.f0efe356.png";